import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Flex,
  Anchor,
  Icon,
  Type,
  Button,
} from "discover.medical.react-component-library";
import { TableRow, TableCell, DescWrapper } from "./index.styled";

const contentCenter = { content: "center" };

const FollowItem = ({
  prettyPubType,
  title,
  isTitleHighlighted,
  slug,
  isMobile,
  onClick,
  onDelete,
  isDeleteEnabled,
  deleteIcon,
}) => (
  <TableRow>
    <TableCell>
      <DescWrapper container column={isMobile}>
        <Flex span={4} cell align={contentCenter}>
          <Type
            element="span"
            display="block"
            fontSize={isMobile ? "sm" : "md"}
            color="gray700"
            textTransform="uppercase"
          >
            {prettyPubType}
          </Type>
        </Flex>
        <Flex span={8}>
          <Anchor
            fontSize="md"
            fontWeight={isTitleHighlighted ? "bold" : "normal"}
            href={slug}
            linkComponent={Link}
            onClick={onClick}
          >
            {title}
          </Anchor>
        </Flex>
      </DescWrapper>
    </TableCell>
    <TableCell align="right">
      <Button
        kind="anchor"
        size="iconOnly"
        padded={false}
        variant="light"
        onClick={onDelete}
        disabled={isDeleteEnabled}
      >
        <Icon
          data-testid="unfollow-icon"
          icon={{
            ...deleteIcon,
            color: isDeleteEnabled
              ? deleteIcon.inactiveColor
              : deleteIcon.color,
          }}
        />
      </Button>
    </TableCell>
  </TableRow>
);

FollowItem.propTypes = {
  prettyPubType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isTitleHighlighted: PropTypes.bool,
  slug: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  isDeleteEnabled: PropTypes.bool,
  deleteIcon: PropTypes.shape({
    glyph: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    inactiveColor: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
  }).isRequired,
};
FollowItem.displayName = "FollowItem";
export default FollowItem;
